import photoFb1 from '../../assets/photoFb1.jpg';
import photoFb1M from '../../assets/photoFb1M.jpg';
import photoFb2 from '../../assets/photoFb2.jpg';
import photoFb2M from '../../assets/photoFb2M.jpg';
import photo1 from '../../assets/photo1.jpg';
import photo1M from '../../assets/photo1M.jpg';

const photoData = {
  inlineFb: [
    {
      desktop: photoFb1,
      mobile: photoFb1M,
      caption:
        'Allogene’s new manufacturing facility, called Cell Forge 1 (“CF1”), in Newark, California, is designed to support clinical trials and the potential commercial production and global distribution of allogeneic CAR T cell products.',
      class: 'photoFb1'
    },
    {
      desktop: photoFb2,
      mobile: photoFb2M,
      caption:
        'Allogene recently launched the industry’s first Phase 2 clinical trial of an allogeneic CAR T at a number of cancer centers in the U.S. These trial sites are now able to provide investigational treatment to patients who often have little to no other treatment options.',
      class: 'photoFb2'
    }
  ],

  inline: [
    {
      desktop: photo1,
      mobile: photo1M,
      caption:
        'The time and logistical complexity of making “autologous” CAR T therapies can create a manufacturing bottleneck and extensive delays in getting treatment to patients.',
      class: 'photo1'
    }
  ]
};

export default photoData;
